/**
 * tdesign v1.0.3
 * (c) 2023 tdesign
 * @license MIT
 */

import { _ as _toConsumableArray } from '../../_chunks/dep-fd3498b6.js';
import { _ as _defineProperty } from '../../_chunks/dep-46de7b2e.js';
import React, { useRef, useMemo } from 'react';
import classNames from 'classnames';
import { CheckCircleFilledIcon, ErrorCircleFilledIcon } from 'tdesign-icons-react';
import { abridgeName, getFileSizeText } from '../../_common/js/upload/utils.js';
import { Link } from '../../link/index.js';
import useCommonClassName from '../../hooks/useCommonClassName.js';
import { Loading } from '../../loading/index.js';
import useDrag from '../hooks/useDrag.js';
import useGlobalIcon from '../../hooks/useGlobalIcon.js';
import { ImageViewer } from '../../image-viewer/index.js';
import parseTNode from '../../_util/parseTNode.js';
import '../../_chunks/dep-2acfafca.js';
import '../../_common/js/log/log.js';
import '../../link/Link.js';
import '../../_chunks/dep-92728dc5.js';
import '../../hooks/useConfig.js';
import '../../config-provider/ConfigContext.js';
import '../../_chunks/dep-d71ee5f3.js';
import '../../_chunks/dep-c3f1141e.js';
import '../../_chunks/dep-4b8f240e.js';
import '../../_chunks/dep-9acbc163.js';
import '../../_chunks/dep-7b52f080.js';
import '../../_chunks/dep-f10515e8.js';
import '../../_chunks/dep-4941ebe7.js';
import '../../_chunks/dep-e9b62d1f.js';
import '../../_chunks/dep-88cd50bf.js';
import '../../_chunks/dep-dcb5aa2a.js';
import '../../_chunks/dep-ee4bf8c2.js';
import '../../_chunks/dep-934eda0c.js';
import '../../_chunks/dep-7dce2c26.js';
import '../../_chunks/dep-12510d64.js';
import '../../_chunks/dep-6b568d83.js';
import '../../_chunks/dep-304e657b.js';
import '../../_chunks/dep-77e34309.js';
import '../../_chunks/dep-6506fbc2.js';
import '../../_chunks/dep-bb5d7b1e.js';
import '../../_chunks/dep-e285f2f8.js';
import '../../_chunks/dep-f4a320cd.js';
import '../../_chunks/dep-ec70b95c.js';
import '../../locale/zh_CN.js';
import '../../_common/js/global-config/locale/zh_CN.js';
import 'dayjs';
import '../../_chunks/dep-cbcc9f89.js';
import '../../_common/js/global-config/default-config.js';
import '../../link/style/css.js';
import '../../loading/Loading.js';
import '../../_chunks/dep-e43cf21c.js';
import '../../_util/dom.js';
import 'raf';
import '../../_chunks/dep-6c5254c6.js';
import '../../_util/easing.js';
import '../../common/Portal.js';
import 'react-dom';
import '../../loading/gradient.js';
import '../../hooks/useDomRefCallback.js';
import '../../_common/js/loading/circle-adapter.js';
import '../../_common/js/utils/set-style.js';
import '../../_common/js/utils/helper.js';
import '../../_chunks/dep-ec16db36.js';
import '../../_chunks/dep-036ad2cc.js';
import '../../_chunks/dep-0e15088f.js';
import '../../loading/defaultProps.js';
import '../../loading/plugin.js';
import '../../_util/react-render.js';
import '../../_chunks/dep-e0370ebe.js';
import '../../loading/style/css.js';
import '../../loading/type.js';
import '../../image-viewer/ImageViewer.js';
import '../../_chunks/dep-10388ab5.js';
import '../../tooltip/index.js';
import '../../tooltip/Tooltip.js';
import '../../popup/index.js';
import '../../popup/Popup.js';
import 'react-transition-group';
import 'react-popper';
import '../../hooks/useControlled.js';
import '../../_chunks/dep-f721d103.js';
import '../../_chunks/dep-4559db64.js';
import '../../_chunks/dep-c00532d4.js';
import '../../_chunks/dep-33ffecad.js';
import '../../_chunks/dep-c1f93350.js';
import '../../_util/noop.js';
import '../../_util/useAnimation.js';
import '../../hooks/usePrevious.js';
import '../../popup/hooks/useTrigger.js';
import 'react-is';
import '../../popup/utils/ref.js';
import '../../_util/composeRefs.js';
import '../../popup/utils/transition.js';
import '../../_util/useMutationObserver.js';
import '../../_chunks/dep-01ce608f.js';
import '../../_chunks/dep-77a54538.js';
import '../../_util/useWindowSize.js';
import '../../popup/defaultProps.js';
import '../../popup/style/css.js';
import '../../popup/type.js';
import '../../tooltip/defaultProps.js';
import '../../tooltip/TooltipLite.js';
import '../../_util/useSwitch.js';
import '../../_util/usePersistFn.js';
import '../../_common/js/utils/getPosition.js';
import '../../tooltip/style/css.js';
import '../../tooltip/type.js';
import '../../locale/LocalReceiver.js';
import '../../config-provider/index.js';
import '../../config-provider/ConfigProvider.js';
import '../../image-viewer/utils.js';
import '../../dialog/index.js';
import '../../dialog/Dialog.js';
import '../../_util/useSetState.js';
import '../../dialog/defaultProps.js';
import '../../dialog/DialogCard.js';
import '../../button/index.js';
import '../../button/Button.js';
import '../../_util/useRipple.js';
import '../../_util/setStyle.js';
import '../../button/defaultProps.js';
import '../../button/style/css.js';
import '../../button/type.js';
import '../../dialog/hooks/useDialogEsc.js';
import '../../dialog/hooks/useLockStyle.js';
import '../../_util/useLayoutEffect.js';
import '../../_common/js/utils/getScrollbarWidth.js';
import '../../dialog/hooks/useDialogPosition.js';
import '../../dialog/hooks/useDialogDrag.js';
import '../../dialog/utils.js';
import '../../_common/js/log/index.js';
import '../../dialog/plugin.js';
import '../../dialog/style/css.js';
import '../../dialog/type.js';
import '../../image-viewer/hooks/useMirror.js';
import '../../image-viewer/hooks/usePosition.js';
import '../../image-viewer/hooks/useIndex.js';
import '../../image-viewer/hooks/useRotate.js';
import '../../image-viewer/hooks/useScale.js';
import '../../image-viewer/hooks/useIconMap.js';
import '../../image-viewer/defaultProps.js';
import '../../image-viewer/hooks/useImageScale.js';
import '../../image-viewer/hooks/useList.js';
import '../../image-viewer/hooks/useViewerScale.js';
import '../../image-viewer/style/css.js';

var DraggerFile = function DraggerFile(props) {
  var _props$trigger;
  var displayFiles = props.displayFiles,
    locale = props.locale,
    disabled = props.disabled;
  var _useCommonClassName = useCommonClassName(),
    SIZE = _useCommonClassName.SIZE;
  var uploadPrefix = "".concat(props.classPrefix, "-upload");
  var drag = useDrag(props.dragEvents);
  var dragActive = drag.dragActive;
  var draggerFileRef = useRef();
  var _useGlobalIcon = useGlobalIcon({
      CheckCircleFilledIcon: CheckCircleFilledIcon,
      ErrorCircleFilledIcon: ErrorCircleFilledIcon
    }),
    CheckCircleFilledIcon$1 = _useGlobalIcon.CheckCircleFilledIcon,
    ErrorCircleFilledIcon$1 = _useGlobalIcon.ErrorCircleFilledIcon;
  var classes = useMemo(function () {
    var _displayFiles$;
    return ["".concat(uploadPrefix, "__dragger"), _defineProperty({}, "".concat(uploadPrefix, "__dragger-center"), !displayFiles[0]), _defineProperty({}, "".concat(uploadPrefix, "__dragger-error"), ((_displayFiles$ = displayFiles[0]) === null || _displayFiles$ === void 0 ? void 0 : _displayFiles$.status) === "fail")];
  }, [displayFiles, uploadPrefix]);
  var renderImage = function renderImage() {
    var _file$response;
    var file = displayFiles[0];
    var url = (file === null || file === void 0 ? void 0 : file.url) || (file === null || file === void 0 ? void 0 : (_file$response = file.response) === null || _file$response === void 0 ? void 0 : _file$response.url);
    return /* @__PURE__ */React.createElement("div", {
      className: "".concat(uploadPrefix, "__dragger-img-wrap")
    }, url && /* @__PURE__ */React.createElement(ImageViewer, {
      images: [url],
      trigger: function trigger(_ref3) {
        var onOpen = _ref3.onOpen;
        return /* @__PURE__ */React.createElement("img", {
          src: url,
          onClick: onOpen
        });
      }
    }));
  };
  var renderUploading = function renderUploading() {
    var file = displayFiles[0];
    if ((file === null || file === void 0 ? void 0 : file.status) === "progress") {
      return /* @__PURE__ */React.createElement("div", {
        className: "".concat(uploadPrefix, "__single-progress")
      }, /* @__PURE__ */React.createElement(Loading, null), /* @__PURE__ */React.createElement("span", {
        className: "".concat(uploadPrefix, "__single-percent")
      }, file.percent, "%"));
    }
  };
  var renderMainPreview = function renderMainPreview() {
    var file = displayFiles[0];
    var fileName = props.abridgeName ? abridgeName.apply(void 0, [file.name].concat(_toConsumableArray(props.abridgeName))) : file.name;
    var fileInfo = /* @__PURE__ */React.createElement(React.Fragment, null, /* @__PURE__ */React.createElement("div", {
      className: "".concat(uploadPrefix, "__dragger-text")
    }, /* @__PURE__ */React.createElement("span", {
      className: "".concat(uploadPrefix, "__single-name")
    }, fileName), file.status === "progress" && renderUploading(), file.status === "success" && /* @__PURE__ */React.createElement(CheckCircleFilledIcon$1, null), file.status === "fail" && /* @__PURE__ */React.createElement(ErrorCircleFilledIcon$1, null)), /* @__PURE__ */React.createElement("small", {
      className: "".concat(SIZE.small)
    }, locale.file.fileSizeText, "\uFF1A", getFileSizeText(file.size)), /* @__PURE__ */React.createElement("small", {
      className: "".concat(SIZE.small)
    }, locale.file.fileOperationDateText, "\uFF1A", file.uploadTime || "-"));
    return /* @__PURE__ */React.createElement("div", {
      className: "".concat(uploadPrefix, "__dragger-progress")
    }, props.theme === "image" && renderImage(), /* @__PURE__ */React.createElement("div", {
      className: "".concat(uploadPrefix, "__dragger-progress-info")
    }, props.fileListDisplay ? parseTNode(props.fileListDisplay, {
      files: displayFiles
    }) : fileInfo, /* @__PURE__ */React.createElement("div", {
      className: "".concat(uploadPrefix, "__dragger-btns")
    }, ["progress", "waiting"].includes(file.status) && !disabled && /* @__PURE__ */React.createElement(Link, {
      theme: "primary",
      hover: "color",
      disabled: disabled,
      className: "".concat(uploadPrefix, "__dragger-progress-cancel"),
      onClick: function onClick(e) {
        var _props$cancelUpload;
        return (_props$cancelUpload = props.cancelUpload) === null || _props$cancelUpload === void 0 ? void 0 : _props$cancelUpload.call(props, {
          e: e,
          file: props.toUploadFiles[0] || props.files[0]
        });
      }
    }, locale === null || locale === void 0 ? void 0 : locale.cancelUploadText), !props.autoUpload && file.status === "waiting" && /* @__PURE__ */React.createElement(Link, {
      theme: "primary",
      hover: "color",
      disabled: disabled,
      onClick: function onClick() {
        var _props$uploadFiles;
        return (_props$uploadFiles = props.uploadFiles) === null || _props$uploadFiles === void 0 ? void 0 : _props$uploadFiles.call(props);
      },
      className: "".concat(uploadPrefix, "__dragger-upload-btn")
    }, locale.triggerUploadText.normal)), ["fail", "success"].includes(file === null || file === void 0 ? void 0 : file.status) && !disabled && /* @__PURE__ */React.createElement("div", {
      className: "".concat(uploadPrefix, "__dragger-btns")
    }, /* @__PURE__ */React.createElement(Link, {
      theme: "primary",
      hover: "color",
      disabled: disabled,
      className: "".concat(uploadPrefix, "__dragger-progress-reupload"),
      onClick: props.triggerUpload
    }, locale.triggerUploadText.reupload), /* @__PURE__ */React.createElement(Link, {
      theme: "danger",
      hover: "color",
      disabled: disabled,
      className: "".concat(uploadPrefix, "__dragger-delete-btn"),
      onClick: function onClick(e) {
        return props.onRemove({
          e: e,
          index: 0,
          file: file
        });
      }
    }, locale.triggerUploadText["delete"]))));
  };
  var renderDefaultDragElement = function renderDefaultDragElement() {
    var _locale$triggerUpload;
    var unActiveElement = /* @__PURE__ */React.createElement("div", null, /* @__PURE__ */React.createElement("span", {
      className: "".concat(uploadPrefix, "--highlight")
    }, (_locale$triggerUpload = locale.triggerUploadText) === null || _locale$triggerUpload === void 0 ? void 0 : _locale$triggerUpload.normal), /* @__PURE__ */React.createElement("span", null, "\xA0\xA0/\xA0\xA0", locale.dragger.draggingText));
    var activeElement = /* @__PURE__ */React.createElement("div", null, locale.dragger.dragDropText);
    return dragActive ? activeElement : unActiveElement;
  };
  var getContent = function getContent() {
    var file = displayFiles[0];
    if (file && (["progress", "success", "fail", "waiting"].includes(file.status) || !file.status)) {
      return renderMainPreview();
    }
    return /* @__PURE__ */React.createElement("div", {
      className: "".concat(uploadPrefix, "__trigger"),
      onClick: props.triggerUpload
    }, props.children || renderDefaultDragElement());
  };
  return /* @__PURE__ */React.createElement("div", {
    ref: draggerFileRef,
    className: classNames(classes),
    onDrop: drag.handleDrop,
    onDragEnter: drag.handleDragenter,
    onDragOver: drag.handleDragover,
    onDragLeave: drag.handleDragleave
  }, ((_props$trigger = props.trigger) === null || _props$trigger === void 0 ? void 0 : _props$trigger.call(props, {
    files: displayFiles,
    dragActive: dragActive
  })) || getContent());
};
DraggerFile.displayName = "DraggerFile";

export { DraggerFile as default };
//# sourceMappingURL=DraggerFile.js.map
